/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';
import { fetchPost as imgFetchPost } from './ImageRequestHandler';

const getRecord = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/getRecord', { data });
  return rst;
};

const addRecord = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/addRecord', { data });
  return rst;
};

const updateRecord = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/updateRecord', { data });
  return rst;
};

const deleteRecord = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/deleteRecord', { data });
  return rst;
};

const addRecordFromExcel = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/addRecordFromExcel', { data });
  return rst;
};

const uploadExcel = async (formData) => {
  const rst = await imgFetchPost('/web_file/uploadExcel', formData);
  return rst;
};

const importExcel = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/importExcel', data);
  return rst;
};

const exportExcel = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/exportExcel', data);
  return rst;
};


const getStatistic = async (data) => {
  const rst = await fetchPost('/web_comfortable_housing/getStatistic', data);
  return rst;
};



export default {
  getRecord,
  addRecord,
  updateRecord,
  deleteRecord,
  addRecordFromExcel,
  uploadExcel,
  importExcel,
  exportExcel,
  getStatistic,
};
